export var StatusSize;
(function (StatusSize) {
    StatusSize["s"] = "12";
    StatusSize["m"] = "16";
    StatusSize["l"] = "24";
    StatusSize["xl"] = "32";
})(StatusSize || (StatusSize = {}));
